import { Component, OnInit, Input,  ViewChild, ElementRef } from '@angular/core';
import { ActivatedRoute, Router, NavigationExtras } from '@angular/router';
import { FormBuilder, FormControl, FormGroup, FormArray, Validators } from '@angular/forms';

import { ProjectmanagementService } from '../../service/projectmanagement.service';
import { ProjectGradeComponent } from '../../forms/projectGrade/ctl.project.grade.component';
import { ProjectSubjectComponent } from '../../forms/projectSubject/ctl.project.subject.component';

import { TranslateService } from '@ngx-translate/core';
import { Subject as Sub } from 'rxjs';
import {Project, Grade, Year, Subject } from '../../model/project.model';

import { MyErrorHandler } from '../../errorhandler/errorhandler';
import * as languageConfig from '../../../../../../src/assets/i18n/configuration/configuration.json';
@Component({
  selector: 'app-paschooladmin',
  templateUrl: './paschooladmin.component.html',
  styleUrls: ['./paschooladmin.component.css'],
  providers: [ProjectmanagementService]
})
export class PaschooladminComponent implements OnInit {
  @ViewChild(ProjectGradeComponent)
    private formProjectGrade: ProjectGradeComponent;
  @ViewChild(ProjectSubjectComponent)
    private formProjectSubject: ProjectSubjectComponent;

  loadedProjectSubject = false;
  loadedProjectGrade = false;
  loaded = false;

  projectData: Project;

  alertMessage;
  alertMessageHeader;

  // grade step
  gradeYearForm: FormGroup;
  yearList: Year[] = [];
  absYearList: Year[] = [];
  projGradeList: Grade[] = [];
  gradeList: Grade[] = [];
  grade_id = ''; // remove it if not needed
  row = [];
  year = '';

  // subject step
  subjectsList: Subject[] = [];
  subjectListAbs: Subject[] = [];
  selectedSubjectsList: Subject[] = [];
  projSubjectList: Subject[];
  subject = '';

  currentSteps = 1;
  project_id: string;
  nextBtnDisbaled = true;
  reviewBtnDisbaled = true;
  wizardSteps = [
    'Add grades',
    'Add subjects',
    'Review & complete'
  ];
  wizardStepsTitle = [
    'Add project grades',
    'Add subjects',
    'Review & complete'
  ];
  languageConfiguration: any;
  textDir:any;
  cancelClicked : Sub<void> = new Sub<void>();
  constructor(private fb: FormBuilder,
              public translate: TranslateService,
              private router: Router,
              private route: ActivatedRoute,
              private projectService: ProjectmanagementService) {
                this.languageConfiguration = (languageConfig as any).default;
                translate.addLangs([this.languageConfiguration.languages]);
                translate.setDefaultLang(this.languageConfiguration.defaultLang);
                let selectedLang = sessionStorage.getItem('selectedLang');
                this.textDir = sessionStorage.getItem('textDir');
                let langRegExp = new RegExp(this.languageConfiguration.languageRegexp);
                if(selectedLang){
                  translate.use(selectedLang.match(langRegExp) ? selectedLang : this.languageConfiguration.defaultLang);  
                } else {
                  const browserLang = translate.getBrowserLang();                  
                  translate.use(browserLang.match(langRegExp) ? browserLang : this.languageConfiguration.defaultLang);  
                }   
              }

  ngOnInit(): void {
    if (window.localStorage.getItem('loginInfoObj') == null) {
      console.log('token info missing');
      this.router.navigate(['/login']);
    }

    // step grade
    this.gradeYearForm = this.fb.group({
      gradeArray: this.fb.array([]),
    });

    const userData = JSON.parse(window.localStorage.getItem('loginInfoObj'));
    if (userData && userData.project && userData.project._id) {
      this.project_id = userData.project._id;
      // this.getProjectData(this.project_id);
      this.initSetup(this.project_id);
    }

    this.route.params.subscribe(params => {
      if (params['project_id']) {
        this.project_id = params['project_id'];
        // this.getProjectData(this.project_id);
        this.initSetup(this.project_id);
      }
    });
  }

  initSetup(project_id) {
    this.loaded = false;
    this.projectService.initSetupProj(project_id).subscribe(
        (data) => {
            const projectData = data[0][0];
            const yearList = data[1];
            const subjectsList = data[2];
            let projGradeList;
            let projSubjectList;
            if (data[0].grades && Object.keys(data[0].grades[0]).length) {
                projGradeList = data[0].grades;
            }
            if (data[0].subjects && Object.keys(data[0].subjects[0]).length) {
                projSubjectList = data[0].subjects;
            }
            this.projectData = projectData;
            this.yearList = yearList;
            this.absYearList = yearList.slice(0);
            this.subjectsList = subjectsList;
            this.subjectListAbs = [...data[2]];
            this.projGradeList = projGradeList;
            this.projSubjectList = projSubjectList;
            this.loaded = true;
        }
    );
  }
  getProjectData(project_id: string) {
    this.projectService.detail(this.project_id).subscribe(
      (response) => {
        this.projectData = response[0];
        this.getYearList();
        if (this.projectData && this.projectData.grades) {
            this.projGradeList = this.projectData.grades;
        }
        if (this.projectData && this.projectData.subjects) {
            this.projSubjectList = this.projectData.subjects;
        }
        console.log('projectData ' + JSON.stringify(this.projectData));
      },
      (err) => {
          console.log('ERROR: ' + err);
          const errorHandlerObj = new MyErrorHandler();
          const errorHandler = errorHandlerObj.handleError(err);
          if (errorHandler.isSssionExpired) {
            this.router.navigate(['/login']);
            return true;
          }
      },
      () => {
          console.log('COMPLETED');
      }
    );
  }
  btnStatus(evt){
    this.nextBtnDisbaled = evt;
  }
  revbtnStatus(evt){
    this.reviewBtnDisbaled = evt;
  }
  removeGrade(i) {
    const control = this.gradeYearForm.controls.gradeArray as FormArray;
    control[i] = this.fb.group({
      name: '',
      year: this.yearList[i]
    });
  }

  getYearList() {
    this.projectService.listYear().subscribe(
      (response) => {
        console.log('Year List :' + JSON.stringify(response));
        this.yearList = response;
        this.loaded = true;
      },
      (err) => {
        console.log('ERROR: ' + err);
        const errorHandlerObj = new MyErrorHandler();
        const errorHandler = errorHandlerObj.handleError(err);
        if (errorHandler.isSssionExpired) {
          this.router.navigate(['/login']);
          return true;
        }
      },
      () => {
          console.log('COMPLETED');
      }
    );
  }

  nextStep() {
    if (this.currentSteps === 1) {
        this.prepareGradeYear();
    }
    if (this.currentSteps === 2) {
        this.prepareSubject();
    }
    this.currentSteps++;
  }

  finalStep() {
    // submit grade and subject, show success/failure message
    // redirect to peojct overview page
    const grades = [];
    const tmp1 = this.gradeList;
    tmp1.forEach(row => {
      if (row && row.name) {
          grades.push({name: row.name, year: row.year._id});
      }

    });

    const subjects = [];
    const tmp2 = this.selectedSubjectsList;
    this.regenerateSubjectList();
    tmp2.forEach(row => {
      if (row && row.name) {
        subjects.push(row._id);
      }
    });
    if (this.gradeList && this.selectedSubjectsList) {
      this.projectService.saveSetupProj(this.project_id, grades, subjects).subscribe(
          (data) => {
              const gradeRes = data[0];
              const subjectRes = data[1];
              window.localStorage.setItem('projectSetupSuccess', this.project_id);
              this.router.navigate(['/projectmanagement', this.project_id, 'view']);
          }
      );
    }
  }
  backStep(step?) {
    if (step) {
      this.currentSteps = step;
      if (step === 1) {
        this.gradeYearForm = this.fb.group({
          gradeArray: this.fb.array([]),
        });
        this.getYearList();
        this.projGradeList = this.gradeList;
      }
    } else {
      if (this.currentSteps === 2){
        this.currentSteps--;
        this.gradeYearForm = this.fb.group({
          gradeArray: this.fb.array([]),
        });
        this.getYearList();
        this.projGradeList = this.gradeList;
      }else{
        this.currentSteps--;
      }
    }
  }

  showYearCategory(year) {
    let lastPos = 0;
    const curPos = this.absYearList.findIndex(x => x.name === year.name);
    if ( curPos ) {
      lastPos = curPos - 1 ;
      if (lastPos < 0) {
        return true;
      }
      if (this.absYearList[lastPos].category === year.category) {
        return false;
      }
    }
    return true;
  }

  addGradesToForm(years: Year[]) {

    let myform: FormGroup;
    myform = this.fb.group({
      gradeArray: this.fb.array([])
    });

    const control = myform.controls.gradeArray as FormArray;
    const gradeDataList = this.projGradeList;
    let j = 0;
    years.forEach(element => {
      if (gradeDataList && gradeDataList.length) {
        let i = 0;
        let flag = false;
        for (const grade of gradeDataList) {
          if (grade.year && grade.year._id === element._id) {
            control.push(this.patchGrade(grade.name, grade.year));
            gradeDataList.splice(i, 1);
            flag = true;
            break;
          }
          i++;
        }
        if (flag === false) {
          control.push(this.patchGrade('', element));
        }
      } else {
        control.push(this.patchGrade('', element));
      }
      if (j >= 6) {
        this.row[j] = false;
      } else {
        this.row[j] = true;
      }
      j++;
    });
    this.gradeYearForm = myform;
    this.loaded = true;
  }

  patchGrade(name, year, classes?) {
    return this.fb.group({
      name: [name],
      year: [year]
    });
  }

  getGradeYearList() {
    this.projectService.listProjectGrade(this.project_id).subscribe(
      (response) => {
        console.log('Grade List :' + JSON.stringify(response));
        this.projGradeList = response;
        this.getYearList();
        this.loaded = true;
        return true;
      },
      (err) => {
        console.log('ERROR: ' + err);
        const errorHandlerObj = new MyErrorHandler();
        const errorHandler = errorHandlerObj.handleError(err);
        if (errorHandler.isSssionExpired) {
          this.router.navigate(['/login']);
          return true;
        }
      },
      () => {
      console.log('COMPLETED');
      }
    );
  }

  getGradeList() {
    this.projectService.listProjectGrade(this.project_id).subscribe(
      (response) => {
        this.projGradeList = response;
        this.loaded = true;
        return true;
      },
      (err) => {
        console.log('ERROR: ' + err);
        const errorHandlerObj = new MyErrorHandler();
        const errorHandler = errorHandlerObj.handleError(err);
        if (errorHandler.isSssionExpired) {
          this.router.navigate(['/login']);
          return true;
        }
      },
      () => {
      console.log('COMPLETED');
      }
    );
  }

  prepareGradeYear() {
    const data = [];
    const tmp = this.gradeYearForm.value.gradeArray;
    tmp.forEach(row => {
      if (row && row.name) {
        data.push(row);
      }
    });

    if (data && data.length > 0) {
      const olddata = JSON.stringify(this.projGradeList);
      const newdata = JSON.stringify(data);
      if (this.projGradeList &&  Object.keys(this.projGradeList).length && olddata === newdata) {
          return true;
      }
      this.gradeList = data;
      this.projGradeList = data;
    }
  }

  updateGradeYear() {
    let data = {};
    const tmp = this.gradeYearForm.value.gradeArray;
    tmp.forEach(row => {
      if (row && row.name && row.year.name === this.year) {
        row.year = row.year._id;
        data = row;
      }
    });

    if (data) {
      this.projectService.updateProjectGrade(this.grade_id , data, this.project_id).subscribe(
        (response) => {
          this.getGradeList();
        },
        (err) => {
          console.log('ERROR: ' + err);
          const errorHandlerObj = new MyErrorHandler();
          const errorHandler = errorHandlerObj.handleError(err);
          if (errorHandler.isSssionExpired) {
            this.router.navigate(['/login']);
            return true;
          }
        },
        () => {
        console.log('COMPLETED');
        }
      );
    }
  }

  getSubjectList() {
    return new Promise((resolve, reject) => {
      this.projectService.listSubject().subscribe(
        (response) => {
          this.subjectsList = response;
          this.subjectListAbs = [...response];
          this.loaded = true;
        },
        (err) => {
          console.log('ERROR: ' + err);
          reject();
        },
        () => {
          console.log('COMPLETED');
          resolve();
        }
      );
    });
  }

  getProjectSubjectList() {
    this.projectService.listProjectSubject(this.project_id).subscribe(
      (response) => {
        this.projSubjectList = response;
      },
      (err) => {
            console.log('ERROR: ' + err);
      },
      () => {
            console.log('COMPLETED');
      }
    );
  }

  onAddSubject(data) {
    if (data && data._id) {
      const i = this.selectedSubjectsList.findIndex(x => x.name === data.name);
      if (i === -1) {
        this.selectedSubjectsList.push(data);
        const i1 = this.subjectsList.findIndex(x => x.name === data.name);
        this.subjectsList.splice(i1, 1);
        this.subject = '';
      } else {
        this.subject = '';
        return;
      }
      this.reviewBtnDisbaled = false;
    } else if (data && data !== '') {
      data =  data.toLowerCase();
      data = data.charAt(0).toUpperCase() + data.slice(1).toLowerCase();
      this.projectService.addSubject({name: data}, this.project_id).subscribe(
        (response) => {
          this.selectedSubjectsList.push({name: data, _id: response.subject_id});
          this.subject = '';
          this.reviewBtnDisbaled = false;
          this.getSubjectList().then(() => {
            const i1 = this.subjectsList.findIndex(x => x.name === data);
            this.subjectsList.splice(i1, 1);
          });
        },
        (err) => {
             console.log('ERROR: ' + err);
        },
        () => {
             console.log('COMPLETED');
        }
      );
    }
  }

  prepareSubject() {
    const data: any = {};
    data.subjects = [];

    this.selectedSubjectsList.forEach(item => {
      data.subjects.push(item._id);
    });
  }

  removeSubject(value) {
    const j = this.selectedSubjectsList.findIndex(x => x.name === value.name);
    this.selectedSubjectsList.splice(j, 1);
    this.regenerateSubjectList();
  }

  regenerateSubjectList(){
    const removeArr = [];
    this.subjectsList = this.subjectListAbs.slice(0);
    console.log(this.subjectListAbs);
    this.subjectListAbs.forEach(value => {
      const j = this.selectedSubjectsList.findIndex(x => x.name === value.name);
      const k = this.subjectsList.findIndex(x => x.name === value.name);
      if (j !== -1){
        removeArr.push(k);
      }
    });
    removeArr.sort().reverse();
    removeArr.forEach((item) => {
      this.subjectsList.splice(item, 1);
    });
  }
}
